import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "classes", "overrides", "className", "isFullWidth", "error", "info"];
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getOverrides, useClasses } from '../../../../utils/overrides';
import { createUseStyles } from '../../../../utils/styles';
import styles from './styles';
var useStyles = createUseStyles(styles, 'FieldBottom');
var Input = /*#__PURE__*/memo(function (_ref) {
  var children = _ref.children,
    classesProp = _ref.classes,
    overridesProp = _ref.overrides,
    classNameProp = _ref.className,
    isFullWidth = _ref.isFullWidth,
    error = _ref.error,
    info = _ref.info,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useClasses(useStyles, classesProp);
  var override = getOverrides(overridesProp, Input.overrides);
  var rootClassName = classnames(classes.root, _defineProperty({}, classes.isFullWidth, isFullWidth), classNameProp);
  if (!error && !info) return null;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: rootClassName
  }, override.root), info && /*#__PURE__*/React.createElement("div", _extends({
    className: classes.info
  }, override.info), info), error && /*#__PURE__*/React.createElement("div", _extends({
    className: classes.error
  }, override.error), error));
});
Input.overrides = ['root', 'error', 'info'];
Input.defaultProps = {};
process.env.NODE_ENV !== "production" ? Input.propTypes = {
  className: PropTypes.string,
  overrides: PropTypes.object,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  info: PropTypes.string
} : void 0;
export default Input;